var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "section-apply-professionals" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-10 offset-md-1" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.what_is_beneat_title")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-left" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.what_is_beneat_detail")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-left" }, [
            _vm._v(
              "\n          เราเป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี เพื่อการพัฒนาระบบการรับงานทำความสะอาดแบบพาร์ทไทม์ ผ่านเทคโนโลยี Application เพื่อให้คุณแม่บ้าน สามารถทำงานพาร์ทไทม์ได้ อย่างสะดวก รวดเร็ว และ ปลอดภัย ในยุคไทยแลนด์ 4.0\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "mt-3 text-left" }, [
            _vm._v(
              "\n          ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท และ ให้กำลังใจคุณแม่บ้าน\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "mt-3 text-left",
            domProps: { innerHTML: _vm._s(_vm.$t("message.apply.sub_title")) }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.introduce_video")))
          ]),
          _vm._v(" "),
          _vm._m(1)
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "content-padding" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.why_work_with_beneat")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-4" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("i", {
            staticClass: "fal fa-clock",
            staticStyle: { "font-size": "60px", color: "#1FBCD2" }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "mt-3" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title01")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail01")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", { attrs: { src: "/static/img/protect.svg", width: "60" } }),
          _vm._v(" "),
          _c("h3", { staticClass: "mt-3" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title02")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail02")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/community.svg", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "mt-3" }, [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title03")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail03")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "content-padding-gray" },
      [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.apply.how_it_works")))
        ]),
        _vm._v(" "),
        !_vm.$mq.phone
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-sm-6 text-right" }, [
                _c("img", {
                  staticClass: "professional-app",
                  attrs: { src: _vm.appPictures[_vm.num] }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "professional-app-step",
                    class: { active: _vm.num === 0 },
                    on: {
                      click: function($event) {
                        _vm.num = 0
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "step-num" }, [
                      _vm._v("1\n          ")
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.stepTitles[0])))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.stepDetails[0])))])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "professional-app-step",
                    class: { active: _vm.num === 1 },
                    on: {
                      click: function($event) {
                        _vm.num = 1
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "step-num" }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.stepTitles[1])))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.stepDetails[1])))])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "professional-app-step",
                    class: { active: _vm.num === 2 },
                    on: {
                      click: function($event) {
                        _vm.num = 2
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "step-num" }, [
                      _vm._v("3\n          ")
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.stepTitles[2])))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.stepDetails[2])))])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "professional-app-step",
                    class: { active: _vm.num === 3 },
                    on: {
                      click: function($event) {
                        _vm.num = 3
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "step-num" }, [
                      _vm._v("4\n          ")
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.stepTitles[3])))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.stepDetails[3])))])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._m(3)
              ])
            ])
          : [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-num-mobile",
                      class: { active: _vm.num === 0 },
                      on: {
                        click: function($event) {
                          _vm.num = 0
                        }
                      }
                    },
                    [_vm._v("1\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-num-mobile",
                      class: { active: _vm.num === 1 },
                      on: {
                        click: function($event) {
                          _vm.num = 1
                        }
                      }
                    },
                    [_vm._v("2\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-num-mobile",
                      class: { active: _vm.num === 2 },
                      on: {
                        click: function($event) {
                          _vm.num = 2
                        }
                      }
                    },
                    [_vm._v("3\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-num-mobile",
                      class: { active: _vm.num === 3 },
                      on: {
                        click: function($event) {
                          _vm.num = 3
                        }
                      }
                    },
                    [_vm._v("4\n          ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 mt-4 text-center active" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.stepTitles[_vm.num])))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t(_vm.stepDetails[_vm.num])))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 mt-3 text-center" }, [
                  _c("img", {
                    staticClass: "professional-app",
                    attrs: { src: _vm.appPictures[_vm.num] }
                  })
                ]),
                _vm._v(" "),
                _vm._m(4)
              ])
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c("section", { staticClass: "content-padding" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 offset-sm-2" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("message.apply.requirements")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "maininfo-list" }, [
            _c("li", [_vm._v(_vm._s(_vm.$t("message.apply.requirements01")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("message.apply.requirements02")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("message.apply.requirements03")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("message.apply.requirements04")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("message.apply.requirements05")))])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.apply.registration_form_link")))
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _vm._m(9),
          _vm._v(" "),
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-body text-center" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-warning btn-block",
                        attrs: {
                          to: "/professional-register",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("message.apply.register")) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-4" }, [
      _c("div", { staticClass: "col-md-2" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8 col-12" }, [
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.apply.contact_data00")))]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.apply.contact_data01")))]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.apply.contact_data03")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [_vm._v(" ")])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6 pl-0" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "/static/img/apply-news01.jpg",
            alt:
              "BeNeat เป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 pr-0" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "/static/img/apply-news02.jpg",
            alt:
              "ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/XgnuTLmSHcA",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
      _c("img", { attrs: { src: "/static/img/wallet.svg", width: "60" } }),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-3" }, [_vm._v("รายได้ดี")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "ผู้ให้บริการในระบบส่วนใหญ๋ได้รับรายได้เฉลี่ยเดือนละ 20,000-40,000 บาท (ขึ้นอยู่กับความขยันและความตั้งใจทำงาน)"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://itunes.apple.com/th/app/beneat-cleaner/id1323965255?mt=8",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-app-store.svg" }
          })
        ]
      ),
      _vm._v("\n              \n          "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=com.beneat.android",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-play-store.svg" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mt-4 text-center" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://itunes.apple.com/th/app/beneat-cleaner/id1323965255?mt=8",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-app-store.svg" }
          })
        ]
      ),
      _vm._v("\n              \n          "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=com.beneat.android",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-play-store.svg" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9 mt-3" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/XgnuTLmSHcA",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/YaHw1mGL_kk",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/RqVnTkEySD4",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/PRUsSZZz4xU",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "mt-4" }, [
          _vm._v(
            "\n              BeNeat Academy คือ ศูนย์ฝึกอบรมคุณแม่บ้านที่มีมาตรฐาน โดย คุณแม่บ้านทุกท่านในระบบ จะได้รับการฝึกสอนทั้งทาง ทฤษฎี และ ปฎิบัติโดยผู้เชี่ยวชาญของบีนีท ซึ่งเป็นหลักสูตรที่บีนีทมีการออกแบบมาอย่างดี และ เป็นลิขสิทธิ์เฉพาะ ของบีนีท\n            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [
          _vm._v(
            "\n              ในศูนย์ฝึกอบรมจะประกอบด้วย สิ่งอำนวยความสะดวกทันสมัยต่างๆ ที่จำลองมาจากสภาพหน้างานจริงๆ ไม่ว่าจะเป็นห้องพักลักษณะ บ้าน, condo , สำนักงาน และ โรงแรม ซึ่งคุณแม่บ้านจะได้รับการฝึกฝนให้สามารถรับมือกับ ลักษณะงานที่หลากหลายเกือบทุกประเภท และสร้างความมั่นใจให้กับคุณแม่บ้านก่อนเข้าไปทำงานจริง\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("สมัครผู้ให้บริการ")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d35b192", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d35b192","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/ApplyProfessional.vue
// module id = 1446
// module chunks = 0